// extracted by mini-css-extract-plugin
export default {"btn":"LinkButton_btn__N2Oib","buttonBlock":"LinkButton_buttonBlock__CCidW","white":"LinkButton_white__XvCN8","label":"LinkButton_label__+YShL","gray":"LinkButton_gray__1nig4"};